// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number } from "@altostra/type-validations/lib/primitives";

const isAndOp = (v: any): v is any =>
  objectOf({
    and: arrayOf(
      anyOf(
        string,
        (v: any) => isAndOp(v),
        (v: any) => isOrOp(v)
      )
    ),
  })(v);

const isOrOp = (v: any): v is any =>
  objectOf({
    or: arrayOf(
      anyOf(
        string,
        (v: any) => isAndOp(v),
        (v: any) => isOrOp(v)
      )
    ),
  })(v);

const isFilterComparatorConfig = objectOf({
  colname: string,
  compare_op: string,
  id: string,
  compare_val: anyOf(nullOrUndefined, boolean, number, string, arrayOf(anyOf(boolean, number, string))),
  data_type: anyOf(nullOrUndefined, string),
  is_rhs_column: anyOf(nullOrUndefined, boolean),
});

const isFilterLogicConfig = objectOf({
  id: string,
  expression: arrayOf(anyOf(string, isAndOp, isOrOp)),
  display_name: anyOf(nullOrUndefined, string),
  description: anyOf(nullOrUndefined, string),
  negate_expression: anyOf(nullOrUndefined, boolean),
  merged_joined_asset: anyOf(nullOrUndefined, boolean),
});

const isFilterConfig = objectOf({
  comparators: arrayOf(isFilterComparatorConfig),
  logic: arrayOf(isFilterLogicConfig),
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdConversionEventsResult = objectOf({
  id: string,
  asset: string,
  match_by: string,
  event_type: string,
  event_ts_col: string,
  event_properties: arrayOf(string),
  filter: anyOf(nullOrUndefined, isFilterConfig),
  event_label: anyOf(nullOrUndefined, string),
  match_properties: anyOf(nullOrUndefined, (v: any) => typeof v === "object"),
  conversion_by_row: anyOf(nullOrUndefined, boolean),
  target_metric_col: anyOf(nullOrUndefined, string),
  target_metric_display_name: anyOf(nullOrUndefined, string),
  reporting_value: anyOf(nullOrUndefined, string),
});
